﻿import { Box, Collapse, Flex, Text } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconChevronDown } from "@tabler/icons-react";
import clsx from "clsx";
import { ReactNode } from "react";

interface NestedMenuProps {
  icon: ReactNode;
  isVisible?: boolean;
  label: string;
  className?: string;
  children: ReactNode;
}

export const NestedMenu: React.FC<NestedMenuProps> = ({
  isVisible = true,
  className,
  icon,
  label,
  children,
}) => {
  const [isOpened, { toggle }] = useDisclosure(false);

  return (
    <Box onClick={e => e.stopPropagation()}>
      <Flex
        component="button"
        onClick={toggle}
        gap={4}
        className={clsx(className, "cursor-pointer")}
      >
        {icon}
        {isVisible && (
          <Text
            fz={"sm"}
            tt={"uppercase"}
            fw={isOpened ? 700 : 400}
            inherit
            w={"100%"}
            className="flex items-center gap-3"
          >
            <span>{label}</span>
            <span
              className={clsx("transition-transform", {
                "rotate-180": isOpened,
              })}
            >
              <IconChevronDown size={16} />
            </span>
          </Text>
        )}
      </Flex>
      <Collapse expanded={isOpened && isVisible}>{isVisible && children}</Collapse>
    </Box>
  );
};
